
const personStatus = [
    { id: 1, label: 'Status - Enabled', value: 1 },
    { id: 2, label: 'Status - Disabled', value: 0 },
  ];

export default personStatus;
